type SearchableItem = {
	title: string;
	originalTitle: string;
	alternativeTitles?: string[] | null;
};

const normalize = (text: string) => text.toLowerCase().replace(/ё/g, 'е').trim();

const splitWords = (text: string) =>
	normalize(text)
		.split(/[\s,.()«»"'-]+/)
		.filter(Boolean);

function matchScore(item: SearchableItem, query: string, queryWords: string[]): number | undefined {
	const title = normalize(item.title);
	if (title === query) return 0;
	if (title.startsWith(query)) return 1;

	const titleWords = splitWords(item.title);
	if (queryWords.every((word) => titleWords.some((titleWord) => titleWord.startsWith(word)))) return 2;

	const otherTitles = [item.originalTitle, ...(item.alternativeTitles || [])];
	const otherWords = otherTitles.flatMap(splitWords);
	if (queryWords.every((word) => otherWords.some((otherWord) => otherWord.startsWith(word)))) return 3;

	const allTitles = normalize([item.title, ...otherTitles].join(' '));
	if (queryWords.every((word) => allTitles.includes(word))) return 4;
	return undefined;
}

export function searchItems<T extends SearchableItem>(items: T[], rawQuery: string, limit: number): T[] {
	const query = normalize(rawQuery);
	const queryWords = splitWords(rawQuery);
	if (!queryWords.length) return [];

	return items
		.flatMap((item) => {
			const score = matchScore(item, query, queryWords);
			return score === undefined ? [] : [{item, score}];
		})
		.sort(
			(first, second) =>
				first.score - second.score ||
				first.item.title.length - second.item.title.length ||
				first.item.title.localeCompare(second.item.title),
		)
		.slice(0, limit)
		.map(({item}) => item);
}
